import { FC, useMemo, useState } from 'react'
import { PermittedLandUsesKey } from 'src/common-services/types/zone-types'
import { Colors } from 'src/components/theme'
import { WidgetCard } from 'src/v2/components/widget-card'
import { ParcelZoningUsesContent } from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-uses/content'
import { ParcelZoningUsesFilter } from 'src/v2/views/owner-reveal/insights/parcel-insights/zoning/zoning-uses/filters'

type ParcelZoningUsesProps = {
  type: PermittedLandUsesKey
}

const ParcelZoningUses: FC<ParcelZoningUsesProps> = ({ type }) => {
  const id = useMemo(() => `zoning-${type}`, [type])
  const [search, setSearch] = useState('')

  const title = useMemo(() => {
    switch (type) {
      case 'conditional_uses':
        return 'Conditional Uses'
      case 'as_of_right':
        return 'As Of Rights'
      case 'prohibited':
        return 'Prohibited Use Cases'
      default:
        return ''
    }
  }, [type])

  return (
    <WidgetCard
      id={id}
      title={title}
      headerBgColor={Colors.primaryGreen700}
      headerTextColor={Colors.textWhite}
      loaderHeight={450}
      filters={<ParcelZoningUsesFilter value={search} onChange={setSearch} />}
      sections={[
        {
          content: <ParcelZoningUsesContent type={type} search={search} />,
        },
      ]}
    />
  )
}

export default ParcelZoningUses
